import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Droplet, Shield, Award } from 'lucide-react';
export function IngredientsSection() {
  return <section className="py-24 bg-white" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center mb-16" data-id="element-159">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-160">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-161">
              Pure Ingredients
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-4 mt-2" data-id="element-162">
              What's Inside <span className="text-[#10B981]" data-id="element-163">LymphoriaX</span>
            </h2>
            <p className="text-[#374151] text-lg max-w-2xl mx-auto" data-id="element-164">
              A powerful blend of natural herbs scientifically formulated to
              support healthy lymphatic drainage
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-165">
          {/* Supplement Facts Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-166">
            <div className="absolute inset-0 bg-[#10B981]/10 blur-3xl rounded-full" data-id="element-167"></div>
            <img src="https://cdn.magicpatterns.com/uploads/58zky7rbKHNVQCysjBUQTq/imgi_22_pdp_img5.png" alt="LymphoriaX Supplement Facts" className="relative z-10 w-full rounded-2xl shadow-2xl" data-id="element-168" />
          </motion.div>

          {/* Key Ingredients */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-169">
            <h3 className="text-3xl font-bold text-[#1B5E20] mb-6" data-id="element-170">
              Powerful Natural Ingredients
            </h3>

            <div className="space-y-4" data-id="element-171">
              {[{
              icon: <Leaf className="w-6 h-6" data-id="element-172" />,
              name: 'Cleavers Aerial Parts',
              description: 'Traditional lymphatic support herb that promotes healthy fluid movement'
            }, {
              icon: <Droplet className="w-6 h-6" data-id="element-173" />,
              name: 'Red Clover Flower',
              description: 'Supports circulation and helps cleanse the lymphatic system naturally'
            }, {
              icon: <Shield className="w-6 h-6" data-id="element-174" />,
              name: 'Stillingia Root',
              description: 'Promotes gentle detoxification and lymphatic drainage'
            }, {
              icon: <Award className="w-6 h-6" data-id="element-175" />,
              name: 'Prickly Ash Bark',
              description: 'Stimulates circulation and supports healthy lymph flow'
            }].map((ingredient, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start space-x-4 p-4 rounded-xl bg-gradient-to-br from-[#F0FFF4] to-white border border-[#10B981]/10" data-id="element-176">
                  <div className="bg-[#10B981] text-white p-3 rounded-full flex-shrink-0" data-id="element-177">
                    {ingredient.icon}
                  </div>
                  <div data-id="element-178">
                    <h4 className="font-bold text-[#1B5E20] mb-1" data-id="element-179">
                      {ingredient.name}
                    </h4>
                    <p className="text-sm text-[#374151]" data-id="element-180">
                      {ingredient.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            <div className="bg-[#10B981]/10 p-6 rounded-xl border-2 border-[#10B981]/20 mt-6" data-id="element-181">
              <h4 className="font-bold text-[#1B5E20] mb-2" data-id="element-182">How to Use:</h4>
              <p className="text-[#374151]" data-id="element-183">
                Take 1 mL (approximately 15-20 drops or ¼ teaspoon) in water
                twice daily for best results.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Lifestyle Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-184">
          <img src="https://cdn.magicpatterns.com/uploads/w8wCyARZLPynfEGaMcmnro/imgi_56_5b6d9d82-0652-49e7-96b4-10f2068f28e9.png" alt="Woman using LymphoriaX" className="w-full h-auto" data-id="element-185" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end p-8 md:p-12" data-id="element-186">
            <div className="text-white max-w-2xl" data-id="element-187">
              <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-188">
                Feel the Difference Every Morning
              </h3>
              <p className="text-lg opacity-90" data-id="element-189">
                Join thousands of women who start their day with LymphoriaX and
                experience lasting energy, reduced puffiness, and natural
                vitality.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}